import * as storageTypes from "./storageTypes";

let userStorage = {};

userStorage.clear = () => localStorage.clear();

////////////////////// Get //////////////////////
userStorage.getUser = () => {
  let result = JSON.parse(localStorage.getItem(storageTypes.USER));
  return result;
};

////////////////////// Set //////////////////////
userStorage.setUser = value => {
  localStorage.setItem(storageTypes.USER, JSON.stringify(value));
};

export default userStorage;
